import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { CaretRight } from 'phosphor-react';
import { useTheme } from 'emotion-theming';
import { Mastercard, Paypal, Visa } from '../../icons';
import { Text } from '../..';
import { ThemeProps } from '../../../types';

type PaymentMethod = 'braintree' | 'vodafone';

export interface PaymentDetails {
  [key: string]: {
    content: () => ReactNode;
    name: string;
    onClick: () => void;
  };
}

export interface PaymentButtonsProps {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * The array of payment methods available
   */
  paymentMethods: PaymentMethod[];
}

const renderPaymentDetails: PaymentDetails = {
  braintree: {
    name: 'braintree',
    onClick: () => console.log('clicked'),
    content: () => (
      <>
        <Text color='primary' element='span' weight='light'>
          {'Card or Paypal'}
        </Text>
        <Visa height={20} width={40} />
        <Mastercard height={20} width={40} />
        <Paypal height={20} width={40} />
      </>
    ),
  },
  vodafone: {
    name: 'vodafone',
    onClick: () => console.log('clicked'),
    content: () => (
      <Text color='primary' element='span' weight='light'>
        {'Vodafone'}
      </Text>
    ),
  },
};

const PaymentButtons = ({ className, paymentMethods }: PaymentButtonsProps) => {
  const theme: ThemeProps = useTheme();

  return (
    <div className={className}>
      {paymentMethods.map((method: PaymentMethod) => {
        const { content, name, onClick } = renderPaymentDetails[method];
        return (
          <button key={name} onClick={onClick}>
            <div>{content()}</div>
            <CaretRight
              color={theme.colors.common.darkGrey}
              size={24}
              weight='bold'
            />
          </button>
        );
      })}
    </div>
  );
};

const StyledPaymentButton = styled((props: any) => (
  <PaymentButtons {...props} />
))`
  ${({ theme }: { theme: ThemeProps }) => ({
    button: {
      alignItems: 'center',
      backgroundColor: theme.colors.common.white,
      borderColor: theme.colors.common.grey,
      borderStyle: 'solid',
      borderWidth: 1,
      borderRadius: 0,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '18px 12px',
      width: '100%',
      '&:active': {
        opacity: 0.8,
        transform: 'scale(0.99)',
      },
      '&:hover': {
        opacity: 0.9,
      },
      '&:not(:first-child)': {
        marginTop: '-1px',
      },
      div: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        span: {
          marginRight: 16,
        },
      },
    },
  })}
`;

export default StyledPaymentButton;
